export default class StringHelper{

    static prettyDecimal(decimal){
        try {
            return String(Number(decimal)
                .toFixed(4))
                .replace(/0+$/, '')
                .replace(/\.$/, '')
        }catch (e) {
            return ""
        }
    }
}